import React from 'react';
import PodDashboard from "./dashboard/pod-dashboard";

const Pods = ({}) => {
    return (
        <>
            <PodDashboard/>
        </>
    )
}

export default Pods
